import style from './style.module.css';

export default function Loader() {
  return (
    <span className="m-36">
      <span className={`${style.loader} w-3 h-3 md:w-4 md:h-4`}></span>
    </span>
  );
}

export function LoaderBtn() {
  return <span className={`${style.loaderBtn} w-3 h-3`}></span>;
}

export function LoaderBtnDelete() {
  return <span className={`${style.loaderBtnDelete} w-3 h-3`}></span>;
}
